(function () {
  if (window.__dillJohanBlogCheckboxFilterHotfix) return;
  window.__dillJohanBlogCheckboxFilterHotfix = true;

  var css = [
    'body.template--blog .blog__filter-control { display: flex !important; align-items: center !important; gap: 1rem !important; cursor: pointer !important; -webkit-tap-highlight-color: transparent !important; }',
    'body.template--blog .blog__filter-box { position: relative !important; flex: 0 0 auto !important; width: 2.2rem !important; height: 2.2rem !important; border: .16rem solid rgba(172,98,36,.62) !important; border-radius: .38rem !important; background: #fffdf9 !important; box-shadow: inset 0 0 0 .38rem #fffdf9, 0 .2rem .9rem rgba(11,10,8,.04) !important; }',
    'body.template--blog .blog__filter-box::after { content: "" !important; position: absolute !important; top: .28rem !important; left: .66rem !important; width: .5rem !important; height: 1rem !important; border-bottom: .2rem solid #fffdf9 !important; border-right: .2rem solid #fffdf9 !important; opacity: 0 !important; transform: rotate(38deg) !important; }',
    'body.template--blog .blog__filters-item.is-active .blog__filter-control { background: #fbf8f3 !important; color: #0b0a08 !important; }',
    'body.template--blog .blog__filters-item.is-active .blog__filter-box { border-color: #ac6224 !important; background: #ac6224 !important; }',
    'body.template--blog .blog__filters-item.is-active .blog__filter-box::after { opacity: 1 !important; }',
    'body.template--blog #ProductGridContainer.is-blog-filter-loading { opacity: .62 !important; transition: opacity 160ms ease !important; }',
    '@media screen and (min-width: 990px) { body.template--blog .blog__filter-control { padding: 2.2rem 3rem !important; } }'
  ].join('\n');

  function injectStyle() {
    var style = document.getElementById('dill-johan-blog-checkbox-filter-hotfix');
    if (!style) {
      style = document.createElement('style');
      style.id = 'dill-johan-blog-checkbox-filter-hotfix';
      document.head.appendChild(style);
    }
    if (style.textContent !== css) style.textContent = css;
  }

  function normaliseHandle(value) {
    return String(value || '').trim().toLowerCase();
  }

  function replaceNode(node) {
    if (!node || !node.parentNode) return node;
    var clone = node.cloneNode(true);
    node.parentNode.replaceChild(clone, node);
    return clone;
  }

  function buildArrow(direction) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'blog__filters-arrow blog__filters-arrow--' + direction + ' no-js-hidden';
    button.setAttribute('aria-label', direction === 'prev' ? 'Scroll blog categories left' : 'Scroll blog categories right');
    button.setAttribute(direction === 'prev' ? 'data-blog-filters-prev' : 'data-blog-filters-next', '');
    return button;
  }

  function enhance() {
    injectStyle();
    var root = document.querySelector('.blog[data-blog-url], .blog');
    if (!root || root.dataset.djBlogCheckboxHotfixReady === 'true') return;
    var head = root.querySelector('.blog__head');
    var originalScroller = root.querySelector('[data-blog-filters-scroller], .blog__filters');
    if (!head || !originalScroller) return;

    root.dataset.djBlogCheckboxHotfixReady = 'true';

    var scroller = replaceNode(originalScroller);
    scroller.setAttribute('data-blog-filters-scroller', '');
    scroller.dataset.blogFiltersBlockClick = 'false';

    var prev = replaceNode(head.querySelector('[data-blog-filters-prev]'));
    var next = replaceNode(head.querySelector('[data-blog-filters-next]'));
    if (!prev) {
      prev = buildArrow('prev');
      head.appendChild(prev);
    }
    if (!next) {
      next = buildArrow('next');
      head.appendChild(next);
    }

    var blogUrl = root.getAttribute('data-blog-url') || '/blogs/blog';
    var blogIndexUrl = blogUrl + '?page=1';
    var filterCache = new Map();
    var selectedFilters = new Set();
    var dragBlock = false;
    var tapCandidate = null;
    var suppressNextClick = false;

    function getProductGridContainer() {
      return root.querySelector('#ProductGridContainer');
    }

    function getFilterControls() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-blog-filter-option]'));
    }

    function getAllControl() {
      return root.querySelector('[data-blog-filter-clear]');
    }

    function seedSelectedFilters() {
      selectedFilters.clear();
      getFilterControls().forEach(function (control) {
        var handle = normaliseHandle(control.dataset.blogFilterHandle);
        if (!handle) return;
        var activeItem = control.closest('.blog__filters-item');
        if (control.getAttribute('aria-pressed') === 'true' || (activeItem && activeItem.classList.contains('is-active'))) {
          selectedFilters.add(handle);
        }
        control.setAttribute('role', 'checkbox');
      });
      var allControl = getAllControl();
      if (allControl) allControl.setAttribute('role', 'checkbox');
      try {
        var params = new URLSearchParams(window.location.search);
        var queryFilters = params.get('filters');
        if (queryFilters) {
          selectedFilters.clear();
          queryFilters.split(',').forEach(function (handle) {
            handle = normaliseHandle(handle);
            if (handle) selectedFilters.add(handle);
          });
        }
      } catch (error) {}
    }

    function setControlsState() {
      var hasFilters = selectedFilters.size > 0;
      var allControl = getAllControl();
      if (allControl) {
        allControl.setAttribute('aria-pressed', hasFilters ? 'false' : 'true');
        allControl.setAttribute('aria-checked', hasFilters ? 'false' : 'true');
        var allItem = allControl.closest('.blog__filters-item');
        if (allItem) allItem.classList.toggle('is-active', !hasFilters);
      }
      getFilterControls().forEach(function (control) {
        var active = selectedFilters.has(normaliseHandle(control.dataset.blogFilterHandle));
        control.setAttribute('aria-pressed', active ? 'true' : 'false');
        control.setAttribute('aria-checked', active ? 'true' : 'false');
        var item = control.closest('.blog__filters-item');
        if (item) item.classList.toggle('is-active', active);
      });
    }

    function setUrlState() {
      var filters = Array.from(selectedFilters);
      var nextUrl = blogIndexUrl;
      if (filters.length === 1) {
        nextUrl = blogUrl + '/tagged/' + filters[0];
      } else if (filters.length > 1) {
        nextUrl = blogUrl + '?filters=' + encodeURIComponent(filters.join(','));
      }
      if (window.location.pathname + window.location.search !== nextUrl) {
        history.pushState({ blogFilters: filters }, '', nextUrl);
      }
    }

    function setBusy(isBusy) {
      var container = getProductGridContainer();
      if (!container) return;
      container.setAttribute('aria-busy', isBusy ? 'true' : 'false');
      container.classList.toggle('is-blog-filter-loading', isBusy);
    }

    function getNextUrl(doc) {
      var loadMore = doc.querySelector('collection-load-more');
      if (!loadMore || loadMore.classList.contains('hidden')) return '';
      var button = loadMore.querySelector('.js-btn-load-more[data-href]');
      return button ? button.dataset.href : '';
    }

    function uniqueArticleCards(docs) {
      var seen = new Set();
      var cards = [];
      docs.forEach(function (doc) {
        doc.querySelectorAll('[data-blog-article-card]').forEach(function (card) {
          var link = card.querySelector('a[href]');
          var key = link ? link.getAttribute('href') : card.dataset.blogTitle;
          if (!key || seen.has(key)) return;
          seen.add(key);
          cards.push(card.outerHTML);
        });
      });
      return cards;
    }

    async function fetchDocument(url) {
      var response = await fetch(url, { credentials: 'same-origin' });
      var text = await response.text();
      return new DOMParser().parseFromString(text, 'text/html');
    }

    async function fetchTaggedDocuments(handle) {
      if (filterCache.has(handle)) return filterCache.get(handle);
      var docs = [];
      var url = blogUrl + '/tagged/' + handle;
      var guard = 0;
      while (url && guard < 6) {
        guard += 1;
        var doc = await fetchDocument(url);
        docs.push(doc);
        url = getNextUrl(doc);
      }
      filterCache.set(handle, docs);
      return docs;
    }

    async function replaceWithSinglePage(url) {
      var doc = await fetchDocument(url);
      var nextContainer = doc.querySelector('#ProductGridContainer');
      var container = getProductGridContainer();
      if (!nextContainer || !container) return;
      container.innerHTML = nextContainer.innerHTML;
    }

    async function replaceWithMergedFilters() {
      var container = getProductGridContainer();
      var grid = container && container.querySelector('#product-grid');
      if (!grid) return;
      var docGroups = await Promise.all(Array.from(selectedFilters).map(fetchTaggedDocuments));
      var docs = docGroups.reduce(function (acc, group) {
        return acc.concat(group);
      }, []);
      var cards = uniqueArticleCards(docs);
      grid.innerHTML = cards.length ? cards.join('') : '<div class="blog__articles-empty text-center"><p>No articles found.</p></div>';
      var loadMore = container.querySelector('collection-load-more');
      if (loadMore) loadMore.classList.add('hidden');
    }

    async function applyFilters(options) {
      options = options || {};
      setControlsState();
      setBusy(true);
      var filters = Array.from(selectedFilters);
      try {
        if (filters.length === 0) {
          await replaceWithSinglePage(blogIndexUrl);
        } else if (filters.length === 1) {
          await replaceWithSinglePage(blogUrl + '/tagged/' + filters[0]);
        } else {
          await replaceWithMergedFilters();
        }
        if (!options.skipUrl) setUrlState();
      } catch (error) {
        if (filters.length === 1) window.location.href = blogUrl + '/tagged/' + filters[0];
      } finally {
        setControlsState();
        setBusy(false);
      }
    }

    function activateControl(control) {
      if (control.hasAttribute('data-blog-filter-clear')) {
        selectedFilters.clear();
      } else {
        var handle = normaliseHandle(control.dataset.blogFilterHandle);
        if (!handle) return;
        if (selectedFilters.has(handle)) selectedFilters.delete(handle);
        else selectedFilters.add(handle);
      }
      applyFilters();
    }

    function handleFilterClick(event) {
      var control = event.target.closest('[data-blog-filter-option], [data-blog-filter-clear]');
      if (!control || !scroller.contains(control)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (suppressNextClick) {
        suppressNextClick = false;
        return;
      }
      if (dragBlock) return;
      activateControl(control);
    }

    function handleFilterPointerDown(event) {
      var control = event.target.closest('[data-blog-filter-option], [data-blog-filter-clear]');
      if (!control || !scroller.contains(control)) {
        tapCandidate = null;
        return;
      }
      tapCandidate = {
        control: control,
        pointerId: event.pointerId,
        x: event.clientX,
        y: event.clientY
      };
    }

    function handleFilterPointerUp(event) {
      if (!tapCandidate || tapCandidate.pointerId !== event.pointerId) return;
      var control = tapCandidate.control;
      var deltaX = event.clientX - tapCandidate.x;
      var deltaY = event.clientY - tapCandidate.y;
      tapCandidate = null;
      if (!control || !scroller.contains(control)) return;
      if (Math.sqrt((deltaX * deltaX) + (deltaY * deltaY)) > 18 || dragBlock) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressNextClick = true;
      window.setTimeout(function () {
        suppressNextClick = false;
      }, 260);
      activateControl(control);
    }

    function updateArrows() {
      var max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      var hasOverflow = max > 4;
      prev.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
      prev.disabled = scroller.scrollLeft <= 4;
      next.disabled = scroller.scrollLeft >= max - 4;
    }

    function move(multiplier) {
      scroller.scrollBy({ left: scroller.clientWidth * multiplier, behavior: 'smooth' });
    }

    function attachDrag() {
      var isDown = false;
      var startX = 0;
      var startScrollLeft = 0;
      var didDrag = false;
      var threshold = 18;

      scroller.querySelectorAll('a').forEach(function (link) {
        link.setAttribute('draggable', 'false');
      });

      function finish(event) {
        if (!isDown) return;
        isDown = false;
        scroller.classList.remove('is-pointer-down', 'is-dragging');
        try {
          if (event && scroller.hasPointerCapture && scroller.hasPointerCapture(event.pointerId)) {
            scroller.releasePointerCapture(event.pointerId);
          }
        } catch (error) {}
        if (didDrag) {
          dragBlock = true;
          window.setTimeout(function () {
            dragBlock = false;
          }, 180);
        }
      }

      scroller.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        isDown = true;
        didDrag = false;
        startX = event.clientX;
        startScrollLeft = scroller.scrollLeft;
        scroller.classList.add('is-pointer-down');
        try {
          if (scroller.setPointerCapture) scroller.setPointerCapture(event.pointerId);
        } catch (error) {}
      });

      scroller.addEventListener('pointermove', function (event) {
        if (!isDown) return;
        var delta = event.clientX - startX;
        if (Math.abs(delta) > threshold) {
          didDrag = true;
          scroller.classList.add('is-dragging');
        }
        if (didDrag) {
          scroller.scrollLeft = startScrollLeft - delta;
          event.preventDefault();
        }
      }, { passive: false });

      scroller.addEventListener('pointerup', finish);
      scroller.addEventListener('pointercancel', finish);
      scroller.addEventListener('pointerleave', finish);
    }

    prev.addEventListener('click', function () { move(-0.74); });
    next.addEventListener('click', function () { move(0.74); });
    scroller.addEventListener('pointerdown', handleFilterPointerDown, true);
    scroller.addEventListener('pointerup', handleFilterPointerUp, true);
    scroller.addEventListener('pointercancel', function () { tapCandidate = null; }, true);
    scroller.addEventListener('click', handleFilterClick, true);
    scroller.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    window.addEventListener('popstate', function () {
      seedSelectedFilters();
      applyFilters({ skipUrl: true });
    });

    seedSelectedFilters();
    setControlsState();
    attachDrag();
    updateArrows();
    window.setTimeout(updateArrows, 500);
    window.setTimeout(updateArrows, 1200);
  }

  document.addEventListener('DOMContentLoaded', enhance);
  window.addEventListener('load', enhance);
  window.setTimeout(enhance, 100);
  window.setTimeout(enhance, 700);
  window.setTimeout(enhance, 1800);
  enhance();
})();
